import { useCallback } from 'react'
import { useSubmitButton } from '../../../../containers/SingleSheetV2/hooks/submitButton'
import { OpenConfirmDialog } from '../../components/dialog/ConfirmDialog'
import { intl } from '../../../../../i18n'

export const useTicketSubmitButton = (
  ticketTypeIsChanged: boolean,
  openConfirmDialog: OpenConfirmDialog,
  ...paramsForUseSubmitButton: Parameters<typeof useSubmitButton>
): ReturnType<typeof useSubmitButton> => {
  const { onClickSubmitButton, submitButtonIsActive } = useSubmitButton(
    ...paramsForUseSubmitButton
  )
  const onClickTicketSubmitButton = useCallback<
    typeof onClickSubmitButton
  >(() => {
    if (ticketTypeIsChanged) {
      openConfirmDialog({
        title: intl.formatMessage({
          id: 'ticketType.change.confirmation.title',
        }),
        message: intl.formatMessage({
          id: 'ticketType.change.confirmation.message',
        }),
        confirm: onClickSubmitButton,
      })
      return Promise.resolve()
    }
    return onClickSubmitButton()
  }, [ticketTypeIsChanged, openConfirmDialog, onClickSubmitButton])

  return {
    onClickSubmitButton: onClickTicketSubmitButton,
    submitButtonIsActive,
  }
}
